import { useEffect, useState } from "react";

import { useTheme } from "../../../context/ThemeContext";
import { cn } from "../../ui/cn";
import centinelaDark from "../../../../assets/centinela-dark.png";
import centinelaLight from "../../../../assets/centinela-light.png";

export const CENTINELA_AVATAR_SIZES = {
  xs: "h-5 w-5",
  sm: "h-7 w-7",
  md: "h-8 w-8",
  lg: "h-9 w-9",
  xl: "h-16 w-16",
} as const satisfies Record<string, string>;

export type CentinelaAvatarSize = keyof typeof CENTINELA_AVATAR_SIZES;

export interface CentinelaAvatarProps {
  size?: CentinelaAvatarSize;
  pulse?: boolean;
  className?: string;
}

export default function CentinelaAvatar({
  size = "md",
  pulse = false,
  className,
}: CentinelaAvatarProps) {
  const { isDarkMode } = useTheme();
  const [entered, setEntered] = useState(false);

  const source = isDarkMode ? centinelaDark : centinelaLight;

  useEffect(() => {
    const timer = setTimeout(() => setEntered(true), 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <span
      className={cn(
        "relative inline-flex shrink-0 items-center justify-center overflow-visible rounded-full",
        CENTINELA_AVATAR_SIZES[size],
        pulse ? "ring-2 ring-primary-500/40 ring-offset-2 ring-offset-app" : undefined,
        className,
      )}
    >
      <img
        key={source}
        src={source}
        alt="Centinela"
        className={cn(
          "relative z-10 h-[80%] w-[80%] object-contain transition-all duration-500 ease-out",
          entered ? "scale-100 opacity-100" : "scale-75 opacity-0",
        )}
      />

      {pulse && (
        <span className="absolute -bottom-0.5 -right-0.5 z-20 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-primary-500 ring-2 ring-app">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-on-primary" />
        </span>
      )}
    </span>
  );
}
